import useHashChange from '@/shared/hooks/useHashChange'

import useDebounce from './useDebounce'
import { useInitKakaoSdk } from './useInitKakaoSdk'
import { useInitNaverSdk } from './useInitNaverSdk'
import useOutsideClick from './useOutsideClick'

const Hooks = {
  useOutsideClick,
  useInitKakaoSdk,
  useInitNaverSdk,
  useDebounce,
  useHashChange
}

export default Hooks
